module.exports = __webpack_public_path__ + "static/img/library_6.5246382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/library_6.jpg
// module id = 1514
// module chunks = 180